import React from 'react';
import { Typography } from 'antd';
import NewsList from '../components/NewsList';

const News: React.FC = () => (
  <div>
    <Typography.Title level={4} style={{ fontWeight: 'bold' }}>News</Typography.Title>
    <div style={{ marginTop: 32 }}>
      <NewsList />
    </div>
  </div>
);

export default News;
